import React, { } from 'react';
import { AiFillCloseCircle } from "react-icons/ai";
import { Image } from 'react-bootstrap';
import MailchimpSubscribe from "react-mailchimp-subscribe";
import subscribeBTN from "../images/SubscribeBTNOrange.png";
import subscribeWhiteBTN from "../images/SubscribeBTN.png";
const mailchimURL = process.env.REACT_APP_MAILCHIMP;

const CustomForm = ({ status, message, onValidated }) => {
    let email, username;
    const submit = () =>
        email &&
        username &&
        email.value.indexOf("@") > -1 &&
        onValidated({
            EMAIL: email.value,
            USERNAME: username.value
        });

    return (
        <div className='popupContent'>
            <Image className="popupLogo" src='./assets/FOTWLogo.png'></Image>
            <p>Receive all the new updates and features firsthand wizard!</p>
            <input

                ref={node => (username = node)}
                type="text"
                placeholder="Username"
                className='modalInput'
                style={{ backgroundImage: `url(${subscribeWhiteBTN})` }}
            />

            <input

                ref={node => (email = node)}
                type="email"
                placeholder="Email"
                className='modalInput'
                style={{ backgroundImage: `url(${subscribeWhiteBTN})` }}
            />
            <button className='subscribeButtonPopup' onClick={submit}
                style={{ backgroundImage: `url(${subscribeBTN})` }}>
                <h2>Subscribe</h2>
            </button>
            {status === "sending" && <div className='textBold'>sending...</div>}
            {status === "error" && (
                <div className='textBold colorRed'
                    dangerouslySetInnerHTML={{ __html: message }}
                />
            )}
            {status === "success" && (
                <div className='textBold colorOrange'
                    dangerouslySetInnerHTML={{ __html: message }}
                >
                    {/* <Navigate replace to="/subscribe" /> */}
                    {/* {navigate('/download')} */}

                </div>

            )}
            <p className='smallText '>
                <br></br>
                None of your information will be shared publicly.
                <br></br>
                You can unsubscribe whenever you want.</p>
        </div>
    );
};

const Modal = ({ open, onClose }) => {
    if (!open) return null;
    return (
        <div onClick={onClose} className='overlayModal'>
            <div
                onClick={(e) => {
                    e.stopPropagation();
                }}
                className='modalContainer'
            >
                <Image className='popupBG' src='./assets/PopupBG.png'></Image>
                <button className='closeBtn' onClick={onClose}>
                    <AiFillCloseCircle></AiFillCloseCircle>
                </button>
                <div className='content'>
                    <MailchimpSubscribe
                        url={mailchimURL}
                        render={({ subscribe, status, message }) => (
                            <CustomForm
                                status={status}
                                message={message}
                                onValidated={formData => subscribe(formData)}
                            />
                        )}
                    />

                </div>
            </div>
        </div>
    );
};

export default Modal;